export default __webpack_public_path__ + "static/video-sound-gong-0e7234e55b5737f5884154fedca2d058.mp3";